import TradeTrustRoute from './TradeTrustRoute'


const routes = [
  new TradeTrustRoute()
]

export default routes
